/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import RatingCommon from '@dtvgo/rating';

/* Utils */
import { useIsBrazil } from '../../providers/ConfigProvider';

/* Styles */
import './Rating.scss';

function Rating({
  rating = '',
  className = '',
}) {
  const isBrazil = useIsBrazil();
  return (
    <RatingCommon
      rating={rating}
      className={`dtv-html5-c-rating ${className}`}
      brazil={isBrazil}
    />
  );
}

Rating.propTypes = {
  rating: PropTypes.string,
  className: PropTypes.string,
};

export default memo(Rating);
